<div
  class="row cbsw-slots-selection-step"
  role="region"
  [attr.aria-label]="'Date and time selection'"
>
  <div
    class="col-md-12 my-2 cbsw-slots-selection-step-title"
    role="heading"
    aria-level="2"
  >
    <app-csw-text
      [text]="bookingService.widgetTemplates | calioMeetingTemplate : { id: templateConstant.WIDGET_CHOOSE_DESIRED_DATE_LABEL, type: 'template' } | translation : 'template_content' : lang"
      customClass="step-element-title fw-600"
    />
  </div>
  @if (widgetService.widgetConf?.context?.show_worker_preview_on_date_selection_step && selectedWorker.id) {
    <div
      class="col-md-12 cbsw-worker-preview-wrapper"
      role="region"
      [attr.aria-label]="'Selected worker information'"
    >
      <div class="row">
        <div class="col-md-6">
          <div class="cbsw-worker-preview">
            <div class="avatar d-flex justify-content-center align-items-start">
              @if (selectedWorker.avatar !== null) {
                <img
                  #image
                  class="resource-avatar rounded-circle"
                  src="{{ workerAvatarBaseUrl }}{{ selectedWorker.uuid }}/thumb_{{ selectedWorker.avatar }}"
                  (error)="
                    image.src = baseUrl + '/img/sample-avatar.png';
                    image.classList.add('default-avatar-margin')
                  "
                  height="200"
                  alt="Worker Avatar"
                />
              } @else {
                <img
                  alt="Worker Avatar"
                  class="default-avatar rounded-circle default-avatar-margin"
                  src="{{ baseUrl }}/img/sample-avatar.png"
                  height="200"
                />
              }
            </div>

            <div class="cbw-worker-detail-description">
              <div class="cbw-worker-title" role="heading" aria-level="3">
                @if (selectedWorker.is_resource === 0) {
                  {{ selectedWorker.resource_name }}
                } @else {
                  {{ selectedWorker | translation: 'booking_label': lang }}
                }
              </div>
              @if (selectedWorker.is_resource === 0 && selectedWorker.job_title?.trim()) {
                <div
                  class="cbw-worker-description"
                  [innerHTML]="(selectedWorker | translation: 'job_title': lang) | trustHtml"
                  role="contentinfo"
                ></div>
              } @else if (selectedWorker.is_resource !== 0 && selectedWorker.description?.trim()) {
                <div
                  class="cbw-worker-description"
                  [innerHTML]="(selectedWorker | translation: 'description': lang) | trustHtml"
                  role="contentinfo"
                ></div>
              }

              @if (+this.bookingService.partnerData?.widget_show_resource_store_name === 1) {
                <div
                  class="cbw-worker-store-location"
                  role="contentinfo"
                  [attr.aria-label]="'Store location'"
                >
                  <span class="cbw-worker-store-location-name">{{ previewStore | translation: 'name' : lang }}</span>
                  @if (previewStore.is_online === 0) {
                    <span class="cbw-worker-store-location-separator">, </span>
                    <span class="cbw-worker-store-location-address whitespace-pre-line">
                      @let addressInput = {
                        street: previewStore.street,
                        zip: previewStore.zip,
                        city: previewStore.city,
                        country: previewStore.country | translation: 'name' : lang,
                        country_code: previewStore.country?.identifier,
                      };
                      {{ addressInput | addressFormat: 'single' }}
                    </span>
                  }
                </div>
              }

              @if (selectedWorker?.attributes?.length) {
                <div role="list" [attr.aria-label]="'Worker attributes'">
                  @for (attribute of selectedWorker.attributes; track attribute.uuid) {
                    @if (attribute.type === 'select') {
                      <div
                        class="attribute-container cbw-attribute-container"
                        role="listitem"
                      >
                        <div class="cbw-attribute">
                          {{ attribute | translation: 'name': lang }}:
                        </div>
                        <div class="attribute-value-section">
                          @for (value of attribute.attributes_values; track value.uuid; let last = $last) {
                            <div class="attribute-value-img">
                              @if (value.icon_url !== null) {
                                <img
                                  #image
                                  class="cbw-attribute-icon"
                                  alt="{{ value.value }}"
                                  src="{{ value.icon_url }}"
                                  (error)="image.src= baseUrl + '/img/sample-avatar.png'"
                                />
                              }
                              <div class="cbw-attribute-value">
                                {{ value | translation: 'value': lang }}
                                @if (!last) { | }
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    } @else {
                      <div
                        class="cbw-attribute cbw-attribute-container"
                        role="listitem"
                      >
                        {{ attribute | translation: 'name': lang }}:
                        @if (attribute.attributes_values?.length) {
                          {{ +attribute.attributes_values[0].value === 1 ? ( 'yes' | translate ): ( 'no' | translate ) }}
                        }
                      </div>
                    }
                  }
                </div>
              }
            </div>
          </div>
        </div>
        <!-- Empty <div> is required to maintain the row structure. -->
        <div class="col-md-6" aria-hidden="true"></div>
      </div>
    </div>
  }
  <div
    class="col-md-6 cbsw-calendar-picker"
    role="region"
    [attr.aria-label]="'Calendar selection'"
  >
    @if (loadCalendarPicker) {
      <app-calio-calendar-picker
        [selectedBookingCartItems]="bookingService.selectedBookingData.cartItems"
        [displayBadgeInBookingFeature]="bookingService.partnerData.is_cart_supported === 1"
        [selectedDate]="selectedDate"
        [disableAutomaticSearch]="bookingService.partnerData.disable_automatic_search"
        [futureBookingThreshold]="bookingService.partnerData.future_booking_threshold_appointments"
        [availableDays]="availableDays"
        [disableAllDays]="true"
        [isMultiselect]="false"
        [timezones]="timezones"
        (selectDaysEvent)="onSelectedDays($event)"
        (monthChangedEvent)="onMonthChangedEvent($event)"
        (onTimezoneChange)="onTimezoneChange($event)"
        role="application"
        [attr.aria-label]="'Select a date for your appointment'"
        [attr.aria-describedby]="'calendar-instructions'"
      />
      <div id="calendar-instructions" class="visually-hidden">
        Use arrow keys to navigate between dates. Press Enter to select a date. Use Page Up and Page Down to change months.
      </div>
    }
  </div>
  <div
    #slotsCardSection
    class="col-md-6 cbsw-slots-card-selection"
    id="slotsCardSection"
    role="region"
    [attr.aria-label]="'Available time slots'"
  >
    <div class="mt-4 mt-md-0">
      @if (showSlotGhostElement) {
        <div
          class="skeleton-box-card"
          role="status"
          aria-live="polite"
          [attr.aria-label]="'Loading available slots'"
        >
          <div role="list" [attr.aria-label]="'Loading time slot options'">
            <div class="row">
              @for (ghostElement of slotGhostElements; track $index) {
                <div class="col-xs-12 col-sm-6 mb-4" role="listitem">
                  <div
                    class="d-flex stats-card shadow"
                    role="presentation"
                    [attr.aria-hidden]="true"
                  >
                    <div class="skeleton-animation w-100 d-flex justify-content-center flex-column align-items-center gap-3">
                      <div class="bar bar-1"></div>
                      <div class="bar bar-2"></div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      } @else {
        @if (noAppointments) {
          <div
            class="cbsw-no-appointments"
            role="alert"
            aria-live="polite"
            [attr.aria-label]="'No appointments available'"
          >
            <div class="text-center">
              <app-csw-text
                [text]="bookingService.widgetTemplates | calioMeetingTemplate : { id: templateConstant.WIDGET_NO_POSSIBLE_APPOINTMENTS_HINT, type: 'template' } | translation : 'template_content' : lang"
                customClass="fw-600"
              />
            </div>
          </div>
        } @else {
          <div
            role="list"
            [attr.aria-label]="'Available time slots for ' + (selectedDate | date:'longDate')"
          >
            @for (slot of availableSlots; track slot) {
              <div
                class="mt-3"
                role="listitem"
              >
                <app-slots-card-selection
                  [slot]="slot"
                  [selectedSlot]="selectedSlot"
                  [selectedBookingCartItems]="bookingService.selectedBookingData.cartItems"
                  [displayBadgeInBookingFeature]="bookingService.partnerData.is_cart_supported === 1"
                  role="button"
                  [attr.aria-label]="'Time slot ' + (slot.start_time | date:'shortTime') + ' to ' + (slot.end_time | date:'shortTime')"
                  [attr.aria-selected]="selectedSlot?.id === slot.id"
                  tabindex="0"
                />
              </div>
            }
          </div>
        }

        @if (freeAppointments?.length) {
          <app-slots-card-selection
            [freeAppointments]="freeAppointments"
            [noAppointments]="noAppointments"
            [freeAppointmentsCount]="freeAppointmentsCount"
            (gotoNextPageEvent)="next()"
          />
        }
      }
    </div>
  </div>
</div>

@if (showSlotsSelectionRequiredError) {
  <div
    class="cbsw-meeting-type-selection-setp-error cbsw-global-step-error"
    role="alert"
    aria-live="assertive"
  >
    <div class="text-danger">
      <div>{{ 'error_messages.select_one_option' | translate }}</div>
    </div>
  </div>
}

<div
  class="d-flex justify-content-end mt-4 mb-4 cbw-custom-navigation"
  role="navigation"
  [attr.aria-label]="'Form navigation'"
>
  <div class="me-2">
    <app-button
      id="{{ 'slot-selection-previous-btn' }}"
      (clickEvent)="previous()"
      [fontColor]="widgetService?.widgetConf?.button_font_color"
      [backgroundColor]="widgetService?.widgetConf?.button_background_color"
      role="button"
      [attr.aria-label]="'Go to previous step'"
    >
      <span class="custom-button-icon back"></span>
      {{ bookingService.widgetTemplates | calioMeetingTemplate : { id: templateConstant.WIDGET_PREVIOUS_BUTTON, type: "template" } | translation : "template_content" : lang }}
    </app-button>
  </div>
  <div>
    <app-button
      id="{{ 'slot-selection-next-btn' }}"
      (clickEvent)="next()"
      [isDisabled]="!selectedDate"
      [fontColor]="widgetService?.widgetConf?.button_font_color"
      [backgroundColor]="widgetService?.widgetConf?.button_background_color"
      role="button"
      [attr.aria-label]="'Continue to next step'"
      [attr.aria-disabled]="!selectedDate"
    >
      {{ bookingService.widgetTemplates | calioMeetingTemplate : { id: templateConstant.WIDGET_NEXT_BUTTON, type: "template" } | translation : "template_content" : lang }}
      <span class="custom-button-icon next"></span>
    </app-button>
  </div>
</div>
